<div class="flex flex-row w-full min-h-screen overflow-x-hidden">
  <!-- Sidebar -->
  <aside
    class="w-18 lg:w-64 bg-white border-r border-purple-200 shadow-sm shrink-0 overflow-hidden"
  >
    <!-- Profile Header -->
    <div class="p-4 border-b border-gray-200 flex items-center justify-between">
      <!-- Desktop: Show full name -->
      <div class="hidden lg:flex items-center space-x-3">
        <div class="bg-gradient-to-br from-purple-500 to-indigo-600 rounded-full w-12 h-12 flex items-center justify-center">
          <svg class="w-7 h-7 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
        <div>
          <p class="text-sm font-medium text-gray-500">Hello</p>
          <h2 class="font-semibold text-gray-800 truncate">{{ userDetails?.name }}</h2>
        </div>
      </div>

      <!-- Mobile: Show only icon -->
      <div class="lg:hidden flex items-center">
        <div class="bg-gradient-to-br from-purple-500 to-indigo-600 rounded-full w-10 h-10 flex items-center justify-center">
          <svg class="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
      </div>
    </div>

    <!-- Navigation Menu -->
    <ul class="py-2 space-y-1">
      <!-- Account Section -->
      <li class="px-4 mt-4 hidden lg:block">
        <p class="text-xs font-bold text-purple-600 uppercase tracking-wider">Account</p>
      </li>

      <!-- Menu Items -->
      <li [ngClass]="{'bg-purple-50 border-l-4 border-purple-600': isOption === 'myprofile'}" (click)="myProfile()" class="cursor-pointer">
        <a class="flex items-center px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-purple-600 transition">
          <svg class="w-6 h-6 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          <span class="ml-3 font-medium hidden lg:inline">Profile Update</span>
        </a>
      </li>

      <li [ngClass]="{'bg-purple-50 border-l-4 border-purple-600': isOption === 'addAddress'}" (click)="updateAddress()" class="cursor-pointer">
        <a class="flex items-center px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-purple-600 transition">
          <svg class="w-6 h-6 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <span class="ml-3 font-medium hidden lg:inline">Update Address</span>
        </a>
      </li>

      <!-- My Stuff -->
      <li class="px-4 mt-4 hidden lg:block">
        <p class="text-xs font-bold text-purple-600 uppercase tracking-wider">My Stuff</p>
      </li>

      <li [ngClass]="{'bg-purple-50 border-l-4 border-purple-600': isOption === 'myorder'}" (click)="myOrder()" class="cursor-pointer">
        <a class="flex items-center px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-purple-600 transition">
          <svg class="w-6 h-6 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
          </svg>
          <span class="ml-3 font-medium hidden lg:inline">My Order</span>
        </a>
      </li>

      <li [ngClass]="{'bg-purple-50 border-l-4 border-purple-600': isOption === 'mywishlist'}" (click)="myWishlist()" class="cursor-pointer">
        <a class="flex items-center px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-purple-600 transition">
          <svg class="w-6 h-6 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
          <span class="ml-3 font-medium hidden lg:inline">My Wishlist ({{ wishlistLength }})</span>
        </a>
      </li>

      <li [ngClass]="{'bg-purple-50 border-l-4 border-purple-600': isOption === 'transcation'}" (click)="myTranscation()" class="cursor-pointer">
        <a class="flex items-center px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-purple-600 transition">
          <svg class="w-6 h-6 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <span class="ml-3 font-medium hidden lg:inline">All Transactions</span>
        </a>
      </li>

      <li [ngClass]="{'bg-purple-50 border-l-4 border-purple-600': isOption === 'reviewrating'}" (click)="reviewRating()" class="cursor-pointer">
        <a class="flex items-center px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-purple-600 transition">
          <svg class="w-6 h-6 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
          </svg>
          <span class="ml-3 font-medium hidden lg:inline">Review & Rating</span>
        </a>
      </li>

      <li [ngClass]="{'bg-purple-50 border-l-4 border-purple-600': isOption === 'notification'}" (click)="Notification()" class="cursor-pointer">
        <a class="flex items-center px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-purple-600 transition">
          <svg class="w-6 h-6 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
          <span class="ml-3 font-medium hidden lg:inline">Notification</span>
        </a>
      </li>

      <li [ngClass]="{'bg-purple-50 border-l-4 border-purple-600': isOption === 'coupons'}" (click)="Coupons()" class="cursor-pointer">
        <a class="flex items-center px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-purple-600 transition">
          <svg class="w-6 h-6 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span class="ml-3 font-medium hidden lg:inline">Coupons</span>
        </a>
      </li>

      <!-- Other -->
      <li class="px-4 mt-4 hidden lg:block">
        <p class="text-xs font-bold text-purple-600 uppercase tracking-wider">Other</p>
      </li>

      <li [ngClass]="{'bg-purple-50 border-l-4 border-purple-600': isOption === 'resetpass'}" (click)="resetPass()" class="cursor-pointer">
        <a class="flex items-center px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-purple-600 transition">
          <svg class="w-6 h-6 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
          <span class="ml-3 font-medium hidden lg:inline">Reset Password</span>
        </a>
      </li>

      <li (click)="logOut()" class="cursor-pointer">
        <a class="flex items-center px-4 py-3 text-gray-700 hover:bg-red-50 hover:text-red-600 transition">
          <svg class="w-6 h-6 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          <span class="ml-3 font-medium hidden lg:inline">Logout</span>
        </a>
      </li>

      <!-- Help -->
      <li class="px-4 mt-4 hidden lg:block">
        <p class="text-xs font-bold text-purple-600 uppercase tracking-wider">Help</p>
      </li>

      <li (click)="helpCenter()" class="cursor-pointer">
        <a class="flex items-center px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-purple-600 transition">
          <svg class="w-6 h-6 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span class="ml-3 font-medium hidden lg:inline">Help Center</span>
        </a>
      </li>
    </ul>
  </aside>

  <!-- Main Content Area -->
  <main class="flex-1 w-full p-1 lg:p-6  overflow-auto">
    <app-add-address *ngIf="isOption === 'addAddress'"></app-add-address>
    <app-myorder-list *ngIf="isOption === 'myorder'"></app-myorder-list>
    <app-my-profile *ngIf="isOption === 'myprofile'"></app-my-profile>
    <app-all-transaction *ngIf="isOption === 'transcation'"></app-all-transaction>
    <app-my-wishlist *ngIf="isOption === 'mywishlist'"></app-my-wishlist>
    <app-review-rating *ngIf="isOption === 'reviewrating'"></app-review-rating>
    <app-coupons *ngIf="isOption === 'coupons'"></app-coupons>
    <app-reset-passwaord *ngIf="isOption === 'resetpass'"></app-reset-passwaord>
    <app-my-notification *ngIf="isOption === 'notification'"></app-my-notification>
  </main>
</div>